"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const yup = __importStar(require("yup"));
const formik_1 = require("formik");
const react_redux_2 = require("react-redux");
const selectors_1 = require("@/store/ducks/components/selectors");
const selectors_2 = require("@/store/ducks/products/selectors");
const products_1 = require("@/store/ducks/products");
const listComponentsUseCase_1 = require("@/useCases/components/listComponentsUseCase");
const createProductUseCase_1 = require("@/useCases/products/createProductUseCase");
const associateProductToComponentsUseCase_1 = require("@/useCases/productsAssociation/associateProductToComponentsUseCase");
const AssociationTable_1 = __importDefault(require("../AssociationTable"));
function CreateProductsAssociationTable() {
    const dispatch = (0, react_redux_2.useDispatch)();
    react_1.default.useEffect(() => {
        (0, listComponentsUseCase_1.listComponents)()(dispatch);
    }, []);
    const componentsRows = (0, react_redux_1.useSelector)(selectors_1.componentTableRowsSelector);
    const productNameToBeAssociated = (0, react_redux_1.useSelector)(selectors_2.productNameToBeAssociatedSelector);
    const isSavePromptVisible = (0, react_redux_1.useSelector)(selectors_2.isSavePromptVisibleSelector);
    const initialValues = react_1.default.useMemo(() => ({
        associatedComponents: [
            { id: "-", unit: "-", order: 0, name: "Select Component" },
        ],
    }), []);
    const autocompleteComponentsOptions = react_1.default.useMemo(() => {
        return componentsRows.map((component) => {
            return {
                label: component.name,
                value: component.id,
                unit: component.unit,
                order: component.order,
            };
        });
    }, [componentsRows]);
    yup.addMethod(yup.array, "uniqueArray", function (mapper = (component) => component, message = "") {
        return this.test("uniqueArray", message, function (list) {
            const uniqueValues = new Set(list?.map(mapper));
            const duplicateItensPositions = [];
            const duplicateIds = list
                ?.map((item) => item?.id)
                .filter((item, index, ids) => ids.indexOf(item) !== index);
            list?.forEach((component) => {
                if (duplicateIds?.includes(component?.id)) {
                    duplicateItensPositions.push(list.indexOf(component));
                }
            });
            const duplicateComponentsErrors = list
                ?.filter((component) => {
                if (component?.id && duplicateIds?.includes(component?.id)) {
                    return component;
                }
            })
                .reduce((acc, curr) => {
                const duplicateComponentIndex = list.indexOf(curr);
                acc = {
                    ...acc,
                    [`${[duplicateComponentIndex]}`]: "Duplicate Value",
                };
                return acc;
            }, {});
            if (uniqueValues?.size !== list?.length) {
                throw this.createError({
                    path: `${this.path}`,
                    message: duplicateComponentsErrors || "error",
                });
            }
            return true;
        });
    });
    const validationSchema = yup.object().shape({
        associatedComponents: yup
            .array()
            .of(yup
            .object()
            .shape({
            order: yup.number(),
            name: yup.string().required("Required").min(1).trim(),
            id: yup.string(),
            unit: yup.string(),
        })
            .required("Required")
            .nullable())
            .uniqueArray((item) => {
            return item?.id;
        }, "Error test"),
    });
    const onSubmit = react_1.default.useCallback(async (values, helpers) => {
        const payload = values.associatedComponents.slice(0, values.associatedComponents.length - 1);
        const productId = await (0, createProductUseCase_1.createProductUseCase)(productNameToBeAssociated)(dispatch);
        if (!productId) {
            dispatch((0, products_1.openProductsToast)({
                status: "error",
                message: "Error saving product",
            }));
            return;
        }
        await (0, associateProductToComponentsUseCase_1.associateProductToComponentsUseCase)(productId, payload)(dispatch).then(() => {
            dispatch((0, products_1.onHideSavePrompt)());
            dispatch((0, products_1.resetProductNameToBeAssociated)(null));
            helpers.resetForm();
        });
    }, [productNameToBeAssociated, dispatch]);
    const onTogglePrompt = react_1.default.useCallback(() => {
        dispatch((0, products_1.onShowSavePrompt)());
    }, [dispatch, products_1.onShowSavePrompt]);
    return (react_1.default.createElement(formik_1.Formik, { onSubmit: onSubmit, initialValues: initialValues, enableReinitialize: true, validationSchema: validationSchema, validateOnChange: true }, (props) => {
        return (react_1.default.createElement(AssociationTable_1.default, { selectComponentOptions: autocompleteComponentsOptions, componentRowInputs: props.values, errors: props.errors, isSavePromptVisible: isSavePromptVisible, onTogglePrompt: onTogglePrompt }));
    }));
}
exports.default = CreateProductsAssociationTable;
